export const TYPE_SPECIAL_GROUP = {
    DEANERY: 'deanery'
}

export const ANNIVERSARIES = {
    BIRTHDAY: 'birth',
    CLERGY: 'linh_muc',
    DIACONUS: 'pho_te'
}

export const DOMAINS = {
    MAP_URL: 'https://maps.giaophanphucuong.org'
}

export const AUDIOS_DEFAULT = 'noi-voi-chinh-minh';
export const DEOCESE_DEFAULT = '35457ea2-8fcd-43b9-9535-22ef79f771da';


export const MASSESTIME = {
    AFTER_SAT: {
        code: 'chieu_thu_bay',
        name: 'Chiều thứ Bảy'
    },
    SUNDAY: {
        code: 'chua_nhat',
        name: 'Chúa Nhật'
    },
    NORMAL: {
        code: 'ngay_thuong',
        name: 'Ngày thường'
    }
}

export const NEWS_TYPE = {
    LOGOS: {
        link: 'loi-chua',
        code: 'loi-chua',
        name: 'Lời Chúa'
    },
    FOCUS: {
        link: 'tinTieuDiem',
        code: 'tin-tieu-diem',
        name: 'Tin Tiêu Điểm'
    },
    LATEST: {
        link: 'tinMoiNhat',
        code: 'tin-moi-nhat',
        name: 'Tin Mới Nhất'
    },
    DIOCESE: {
        code: 'tin-giao-phan',
        name: 'Tin Giáo Phận'
    },
    UNIVERSAL: {
        code: 'tin-giao-hoi-hoan-vu',
        name: 'Tin Giáo Hội Hoàn Vũ'
    },
    MOST_VIEW: {
        link: 'tinXemNhieu',
        code: 'tin-xem-nhieu',
        name: 'Bài Xem Nhiều'
    },
    NEWS_POSTS: {
        link: 'tinMoiNhat',
        code: 'bai-moi',
        name: 'Bài Mới'
    },
    LITURGY: {
        code: 'phung-vu',
        name: 'Phụng Vụ'
    },
    LITURGY_PROBLEMS: {
        code: 'cac-van-de-phung-vu',
        name: 'Các Vấn Đề Phụng Vụ'
    },
    LITURGY_CALENDAR: {
        code: 'lich-phung-vu',
        name: 'Lịch Phụng Vụ'
    },
    LOGOS_COMMON: {
        code: 'loi-nguyen-chung',
        name: 'Lời Nguyện Chung'
    },
    LITURGY_SAINTS: {
        code: 'phung-vu-chu-thanh',
        name: 'Phụng Vụ Chư Thánh'
    },
    CHURCH: {
        code: 'tin-giao-hoi',
        name: 'Tin Giáo Hội'
    },
    CHURCH_VN: {
        code: 'tin-giao-hoi-viet-nam',
        name: 'Tin Giáo Hội Việt Nam'
    },
    TAIZE : {
        code: 'taize',
        name: 'Taize'
    },
    SALT_FOR_LIFE : {
        code: 'muoi-men-cho-doi',
        name: 'Muối Men Cho Đời'
    },
    PRIESTLY_VOCATION: {
        code: 'on-goi-linh-muc',
        name: 'Ơn Gọi Linh Mục'
    },
    NOTIFICATIONS: {
        code: 'thong-bao',
        name: 'Thông Báo'
    },
    DOCUMENT_LIST: {
        code: 'van-kien',
        name: 'Văn Kiện'
    },
    MATERIAL_LIST: {
        code: 'tai-lieu',
        name: 'Tài Liệu'
    },
    PARABLE_LIST: {
        code: 'tu-ngu-kinh-thanh',
        name: 'Từ Ngữ Kinh Thánh'
    }
}

export const HOMEPAGE_DATA_TYPE = {
    NEWS: {
        code: 'news-list',
        name: ''
    },
    DOSSIL: {
        link: 'van-kien',
        code: 'document-list',
        name: 'Văn Kiện'
    },
    PARABLES: {
        link: 'tu-ngu-kinh-thanh',
        code: 'parable-list',
        name: 'Từ Ngữ Kinh Thánh'
    },
    NOTIFICATIONS: {
        link: 'thong-bao',
        code: 'notification-list',
        name: 'Thông Báo'
    }
}

export const CATEGORY_PLAYLIST_MAP = [
    {
        categoryID: 'suy-niem-hang-ngay',
        playlistId: 'PL-uyh2tqni7lzUEH_AVT1oHVCC0RS4WP1'
    },
    {
        categoryID: 'phung-vu-chu-thanh',
        playlistId: 'PL-uyh2tqni7nLxdHqWjTbLyIoJEriY7lM'
    },
    {
        categoryID: 'giam-muc',
        playlistId: 'PL-uyh2tqni7krD7BobEbRbZTB7cvfal5m'
    },
    {
        categoryID: 'thanh-ca',
        playlistId: 'PL-uyh2tqni7nVVcVLYGvl2P-vgwtebfLj'
    }
]
